export default {
    get() {
        return this._modes;
    },

    _modes: [
        {
            heading: 'Text-based Courses',
            body: `Developed by MHA’s education team, our courses are developed specifically for your professional development. They’re referenced from a range of textbooks, peer-reviewed journal articles, selected websites and reputable sources. Text-based courses are available for Standard and Premium members.`,
            icon: '/images/app/learning-modes-about-text.svg'
        },
        {
            heading: `Video-based Courses`,
            body: `Presented by mental health experts from all over the world, MHA’s video courses include webinar, conference and workshop recordings, role-play and real therapy in-session demonstrations, specialised videos series, and more. Video-based courses are available for Premium members. `,
            icon: '/images/app/learning-modes-about-video.svg'
        },
        {
            heading: `MHA Collections`,
            body: `Looking for specialised learning? Our academic team hand-picks courses exploring a common topic, grouping them into “MHA Collections.” With a single click you can add an entire collection to your course list and fast-track your learning in that area. `,
            icon: '/images/app/learning-modes-about-collections.svg'
        },
        {
            heading: `Micro-Credential Courses`,
            body: `MHA Micro-Credential courses are designed to provide a deep-dive, content-rich experience (30+ hours of learning) backed up by real-life case studies, activities and illustrations. These programs, developed in partnership with subject-matter experts, are available outside of membership and require a per course enrolment process (active MHA members can access exclusive discounts when enrolling in Micro-Credential courses).`,
            icon: '/images/app/learning-modes-about-masterclass.svg'
        },
        {
            heading: `Real-Time Webinars`,
            body: `We regularly invite speakers to share their latest research and therapeutic insights with you. Webinar topics cover a wide range of areas, from personal development through to cutting-edge mental health research and practice. Webinars are free for all MHA members.`,
            icon: '/images/app/learning-modes-about-webinars.svg'
        }
    ]
}
